// removed by extract-text-webpack-plugin
module.exports = {"SearchBox":"SearchBox__SearchBox__2DrQQ","Container":"SearchBox__Container__3CuDV","Input":"SearchBox__Input__3m9cP","Icon":"SearchBox__Icon__1-THz"};